module.exports = __webpack_public_path__ + "static/financial_accounts-64338d565956e28ee10428afd1ffdebe.png";